import WTable from "./myCustomerTable/index";
import WExFoldTableCell from "./exFoldTableCell/index";
import WAddress from "./address/index";
import WUpload from "./upload/index";
import WDialog from "./dialog/index";
import WTransform from "./transform/index";
import WEllipsisAndLook from "./ellipsis/index";
import WLookDetail from  "./lookDetailDialog/index";
import WNoteInfoFold from  "./noteInfoFold/index";
import LEDropDownRoute from  "./lingen/routeChange/index";
import LENotFound from './lingen/errorPage/src/compoement/NotFound.vue'
import LEServerError from './lingen/errorPage/src/compoement/ServerError.vue'
import LEDownFilesDialog from './lingen/downRawData/src/compoement/DownFilesDialog.vue'
import LEDownFilesVolcanoDialog from './lingen/downRawDataVolcano/src/compoement/LEDownFilesVolcanoDialog.vue'
import ElementUi from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Viewer.setDefaults({
    Options: {
        'inline': true,        // 是否内联显示
        'button': true,        // 是否显示工具栏按钮
        'navbar': true,        // 是否显示导航条
        'title': false,         // 是否显示图片标题
        'toolbar': true,       // 是否显示工具栏
        'tooltip': true,       // 是否显示提示工具
        'movable': false,       // 是否可移动
        'zoomable': true,      // 是否可缩放
        'rotatable': true,     // 是否可旋转
        'scalable': true,      // 是否可缩放
        'transition': false,    // 是否有过渡效果
        'fullscreen': true,    // 是否支持全屏
        'keyboard': false,      // 是否支持键盘控制
        'url': 'data-source'   // 图片 URL 的数据源属性
    }
})
const install = (Vue, options) => {
    if (install.installed) return;
    install.installed = true;
    // 注册自定义表格组件
    Vue.component(WTable.name, WTable);
    Vue.component(WExFoldTableCell.name, WExFoldTableCell);
    Vue.component(WAddress.name, WAddress);
    Vue.component(WUpload.name, WUpload);
    Vue.component(WDialog.name, WDialog);
    Vue.component(WTransform.name, WTransform);
    Vue.component(WEllipsisAndLook.name, WEllipsisAndLook);
    Vue.component(WLookDetail.name, WLookDetail);
    Vue.component(WNoteInfoFold.name, WNoteInfoFold);
    Vue.component(LEDropDownRoute.name, LEDropDownRoute);
    Vue.component(LENotFound.name, LENotFound);
    Vue.component(LEServerError.name, LEServerError);
    Vue.component(LEDownFilesDialog.name, LEDownFilesDialog);
    Vue.component(LEDownFilesVolcanoDialog.name, LEDownFilesVolcanoDialog);
    Vue.use(Viewer, options);
    // 注册 ElementUI 组件
    for (let componentKey in ElementUi) {
        if(componentKey.includes('Message')){
            Vue.prototype.$messageUi = ElementUi[componentKey];
        }else if(componentKey.includes('Notification')){
            Vue.prototype.$notify = ElementUi[componentKey];
        }else if(componentKey.includes('MessageBox')){
            Vue.prototype.$msgbox = ElementUi[componentKey];
        }
        else {
            Vue.use(ElementUi[componentKey]);
        }
    }
    // 注册 Ant Design Vue 组件
    for (let componentKey in Antd) {
        Vue.use(Antd[componentKey]);
    }
};
export {
    WTable,
    WExFoldTableCell,
    WAddress,
    WUpload,
    WDialog,
    WTransform,
    WEllipsisAndLook,
    WLookDetail,
    WNoteInfoFold,
    LEDropDownRoute,
    LENotFound,
    LEServerError,
    LEDownFilesDialog,
    LEDownFilesVolcanoDialog
};
export default install;
